module.exports = __webpack_public_path__ + "static/media/Yoyo_8220.8b01a2b6.jpg";